import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const getAllExamTypesPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-types-portal/all${qs(filters)}`);
  return res.data;
};

export const getExamTypeByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/exam-types-portal/${id}`);
  return res.data;
};

export const createExamTypePortal = async (data) => {
  const res = await axiosInstance.post("/exam-types-portal/create", data);
  return res.data;
};

export const updateExamTypePortal = async (id, data) => {
  const res = await axiosInstance.put(`/exam-types-portal/update/${id}`, data);
  return res.data;
};

export const deleteExamTypePortal = async (id) => {
  const res = await axiosInstance.delete(`/exam-types-portal/delete/${id}`);
  return res.data;
};
